export default "__VITE_ASSET__B2xPxtK9__"